import { showErrorToast } from '@fff-web/fff-ui-shared/Toast';
import { Step, STEPS } from '../../utils/constants/progressSteps';
import { Friend } from '../../utils/ContextProviders/friendContextTypes';
import { redirectToEdit } from '../../utils/redirectionUtilities';
import { isResponseError } from '../../utils/Data/dataTypes';
import { isCallSuccessful } from '../../utils/Data/dataUtilities';
import { putAvatar } from '../../utils/Data/hermesConnector';
import { postEmailOptIn } from '../../utils/Data/maillistConnector';
import {
  createRegisterRequest, NON_UNIQUE_EMAIL_MESSAGE, postRegisterV2,
} from '../../utils/Data/registerConnector';
import { signPactSafeSocialEcommContracts } from '../../utils/Data/pactSafeConnector';
import createIterableProfile from '../../utils/Data/iterableConnector';
import { trackEvent } from '../../utils/tracking';
import { Country } from '../../utils/ContextProviders/appContextTypes';
import { PaymentType } from '../../utils/Data/registerConnectorTypes';

// lots happening here
// let break it down
// Call endpoint to validate phone number
// on success: continue, on failure: skip to Phone Validation Failure
// send all user data to register-api
// on success: continue, on failure: skip to Register Failure
// subscribe to marketing emails, upload avatar (not concerned about failure)
// redirect to /edit

// Phone Validation Failure: Push user back to /create-account
//      and show error message for phone number
// Register Failure: Toast Popup with error returned from register-api
export const handleSubmission = async (
  token: string,
  friend: Friend,
  setFriend: React.Dispatch<React.SetStateAction<Friend>>,
  goToStep: (step: Step) => void,
  afterRegister: () => void,
  onRegistrationFailed: () => void,
  avatar: File | undefined,
  paymentType: PaymentType,
  socialEcommContracts: any,
  countries: Country[],
  hCaptchaToken: string,
) => {
  const registerResponse = await postRegisterV2(createRegisterRequest(
    token, friend, countries, paymentType,
  ), hCaptchaToken);

  if (!isCallSuccessful(registerResponse.status) && isResponseError(registerResponse)) {
    // email is not unique
    if (registerResponse.error.data.message === NON_UNIQUE_EMAIL_MESSAGE.replace('%s', friend.email)) {
      setFriend({ ...friend, isEmailUnique: false });
      return goToStep(STEPS.CREATE_ACCOUNT);
    }

    if (onRegistrationFailed) {
      onRegistrationFailed();
    }
    // handle other registration errors
    return showErrorToast(
      'Oops! Something went wrong.',
      registerResponse.error.data.message,
    );
  }

  afterRegister();
  // call identify to backup iterable account creation
  createIterableProfile(friend, registerResponse.data.shopUserId);
  // anything else that needs to be done before the redirect should go here
  const preRedirectCalls = [];

  // sign PactSafe contracts
  preRedirectCalls.push(signPactSafeSocialEcommContracts(friend.email, socialEcommContracts));

  if (avatar?.name) {
    preRedirectCalls.push(putAvatar(avatar));
  }

  if (friend.isEmailOptIn) {
    preRedirectCalls.push(postEmailOptIn());
  }

  trackEvent('Invite Redeemed', friend, 'Save & Submit', paymentType, registerResponse.data.shopUserId);

  return Promise.all(preRedirectCalls).finally(() => redirectToEdit());
};

export default handleSubmission;
